module.exports = require("./is.js");